module.exports = __webpack_public_path__ + "img/1.2fce5a94.png";